/**
 * FORM PHONE INPUT WRAPPER
 * Wrapper react-hook-form pour le composant PhoneInput
 */

import type { Control, FieldPath, FieldValues } from 'react-hook-form';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from './form';
import { PhoneInput } from './phone-input';
import type { CountryCode } from './phone-input';

interface FormPhoneInputProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> {
  control: Control<TFieldValues>;
  name: TName;
  label: string;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  /** Code pays par défaut (FR par défaut) */
  defaultCountryCode?: CountryCode;
}

export function FormPhoneInput<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  control,
  name,
  label,
  placeholder,
  required = false,
  disabled = false,
  defaultCountryCode = 'FR',
}: FormPhoneInputProps<TFieldValues, TName>) {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            {label} {required && <span className="text-red-600">*</span>}
          </FormLabel>
          <FormControl>
            <PhoneInput
              value={field.value ?? ''}
              onChange={field.onChange}
              disabled={disabled}
              placeholder={placeholder}
              defaultCountryCode={defaultCountryCode}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
